export enum EstimateEndStateRoutes {
  RepairableRoute = "RepairableRoute",
  TotalLossRoute = "TotalLossRoute",
  OutOfScopeRoute = "OutOfScopeRoute",
  FlowCompleteRoute = "FlowCompleteRoute",
  ExternalRedirect = "ExternalRedirect",
  ErrorPageRoute = "ErrorPageRoute",
}

export interface EndStateRoutes {
  repairable?: EstimateEndStateRoutes;
  totalLoss?: EstimateEndStateRoutes;
  outOfScope?: EstimateEndStateRoutes;
  onTimeout?: EstimateEndStateRoutes;
  onApiError?: EstimateEndStateRoutes;
}
